<template>
    <span
        class="my-2"
        :class="{
            'chip-emerald': status == 'active',
            'chip-rose': status == 'inactive' || status == 'blocked',
            'chip-amber':
                status != 'active' &&
                status != 'inactive' &&
                status != 'blocked',
        }"
    >
        {{ statusName }}
    </span>
</template>

<script>
export default {
    props: ["status"],
    computed: {
        statusName() {
            switch (this.status) {
                case "inactive":
                    return "Inativo";
                case "active":
                    return "Ativo";
                case "blocked":
                    return "Bloqueado";
                case "expired":
                    return "Expirado";
                default:
                    return this.status;
            }
        },
    },
};
</script>
